export default "__VITE_ASSET__DvUEVt2$__"